/**
 * Static expected duration ranges per intent type.
 * Used for variance calculation until the ops agent builds real baselines.
 */

const RANGES: Record<string, [number, number]> = {
  'verse_lookup':           [500,  2000],
  'word_study':             [1000, 4000],
  'topical_question':       [2000, 8000],
  'manuscript_comparison':  [2000, 6000],
  'cross_reference':        [1000, 5000],
  'chapter_summary':        [2000, 8000],
  'commentary_request':     [2000, 8000],
  'study_generation':       [3000, 10000],
  'general_bible':          [1000, 5000],
  'off_topic':              [100,  500],
};

export type Variance = 'fast' | 'normal' | 'slow';

export function getExpectedRange(intent?: string): [number, number] {
  return RANGES[intent ?? ''] ?? [1000, 5000];
}

export function getVariance(durationMs: number, intent?: string): Variance {
  const [low, high] = getExpectedRange(intent);
  if (durationMs < low) return 'fast';
  if (durationMs > high) return 'slow';
  return 'normal';
}
